<template>
	<v-container fill-height>
		<v-layout align-center justify-center>
			<v-overlay :absolute="overlay.absolute" :opacity="overlay.opacity" :value="overlay.status" :z-index="overlay.zIndex"> </v-overlay>
			<v-flex xs12 sm8 md4>
				<v-card class="elevation-12">
					<v-toolbar dark>
						<v-toolbar-title>ورود</v-toolbar-title>
					</v-toolbar>
					<v-card-text>
						<v-form ref="form" v-model="valid" lazy-validation>
							<v-text-field prepend-icon="domain" name="domain" label="Organization" id="domain" type="text" v-model="domain" required :rules="domainRules" dir="ltr"> </v-text-field>
							<v-text-field prepend-icon="person" name="username" label="Username" id="username" type="text" v-model="username" required :rules="userRules" dir="ltr"> </v-text-field>
							<!-- <v-text-field prepend-icon="person" name="email" label="Email" type="email" v-model="email" :rules="emailRules" required> </v-text-field> -->
							<v-text-field prepend-icon="lock" name="password" label="Password" id="password" type="password" required v-model="password" :rules="passwordRules" dir="ltr"> </v-text-field>
						</v-form>
					</v-card-text>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn dark :disabled="!valid" @click="submit">ورود</v-btn>
					</v-card-actions>
				</v-card>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
	export default {
		name: "login",
		data() {
			return {
				overlay: { absolute: false, opacity: 0.46, status: false, zIndex: 5 },
				valid: false,
				// email: "",
				domain: "",
				username: "",
				password: "",
				domainRules: [(v) => !!v || "Organization name is required", (v) => v.length >= 3 || "Organization name must be greater than 3 characters"],
				userRules: [(v) => !!v || "Username is required", (v) => v.length >= 3 || "Username must be greater than 3 characters"],
				// emailRules: [(v) => !!v || "E-mail is required", (v) => /.+@.+/.test(v) || "E-mail must be valid"],
				passwordRules: [(v) => !!v || "Password is required", (v) => v.length >= 3 || "Password must be greater than 3 characters"],
			};
		},
		mounted() {
			document.getElementById("domain").focus();
			if (localStorage.domain) {
				this.domain = localStorage.domain;
				document.getElementById("username").focus();
			}
			if (localStorage.username) {
				this.username = localStorage.username;
				document.getElementById("password").focus();
			}
		},
		methods: {
			async submit() {
				this.overlay.status = true;
				if (this.$refs.form.validate()) {
					localStorage.domain = this.domain;
					localStorage.username = this.username;
					// this.$store.dispatch("spinStart");
					await this.$store
						.dispatch("userLogin", { domain: this.domain, username: this.username, password: this.password })
						.then((loged) => {
							// console.info(1, loged)
							if (loged) {
								this.$router.push(this.$route.query.redirect || "/");
							} else {
								this.overlay.status = false;
								this.password = "";
								this.valid = false;
								document.getElementById("password").focus();
							}
						})
						.catch(() => {
							/*handle errors*/
						});
					// this.$store.dispatch("spinStop");
				}
				this.overlay.status = false;
			},
		},
	};
</script>
